import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link, NavLink } from "react-router-dom";
import AddtoCoupon from "../components/home/addCoupon";
import {  LogoutOutlined,  } from '@ant-design/icons';
import {FaUserCircle} from 'react-icons/fa'
import Logo from "../images/logo.png";
import { motion, AnimatePresence } from "framer-motion";
import { MdKeyboardArrowRight, MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md'
import { useDispatch } from "react-redux";
import { logouthandler } from "../api/authSlice";

export default function Navbar({isAuthenticate, user, balance}) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const dispatch=useDispatch()
  console.log(user)
  const navbar = [
    {
      title: "Home",
      path: "/home",
    },

    {
      title: "E-Vouchers",
      path: "/e-vouchers",
    },

    {
      title: "Products & Gifts",
      path: "/products-gifts",
    },

    {
      title: "Contact",
      path: "/contact",
    },
  ];

  const changeState=()=>{
    
  }
  
  const logoutFutn=()=>{
    dispatch(logouthandler())
  }

  return (
    <div className="bg-[#ffff] shadow-sm sticky top-0 z-40 ">
      <div class=" py-1 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl ">
        <div class=" flex items-center justify-between w-full ">
          <div>
          <Link to="/home">
            <img src={Logo} alt="logo" className=" w-24 md:block hidden " />
          </Link>
          </div>

          <div className="items-center ">
            <ul
              class=" items-center hidden text-[#88448A] mt-5   text-2xl text-transform: uppercase; w-full space-x-8 lg:flex "
              style={{ fontFamily: "Poppins" }}
            >
              {navbar.map((item, i) => {
                return (
                  <li key={i}>
                    <NavLink
                      className="text-[#9A4C9D] hover:text-[#9A4C9D] text-[18px] "
                      activeStyle={{ color: "rgb(38 3 39)", fontWeight: "500" }}
                      to={item.path}
                    >
                      {item.title}
                    </NavLink>
                  </li>
                );
              })}
            </ul>
            
          </div>
          <div className=" w-24 md:block hidden ">
          <AddtoCoupon />
          </div>
        </div>

        <div className="flex items-center justify-between md:hidden px-2">
          <button
            aria-label="Open Menu"
            title="Open Menu"
            class="p-2 -mr-1 transition duration-200 rounded focus:outline-none focus:shadow-outline hover:bg-deep-purple-50 focus:bg-deep-purple-50"
            onClick={() => setIsMenuOpen(true)}
          >
            <svg class="w-5 text-gray-600" viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M23,13H1c-0.6,0-1-0.4-1-1s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,13,23,13z"
              />
              <path
                fill="currentColor"
                d="M23,6H1C0.4,6,0,5.6,0,5s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,6,23,6z"
              />
              <path
                fill="currentColor"
                d="M23,20H1c-0.6,0-1-0.4-1-1s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,20,23,20z"
              />
            </svg>
          </button>

          <div class="lg:hidden">
            {isMenuOpen && (
              // <SidebarWrap
              //   key="first"
              //   initial={{ x: -250, opacity: 0 }}
              //   animate={{ x: 0, opacity: 1 }}
              //   exit={{ x: -280, opacity: 1 }}
              //   transition={{
              //     duration: 0.36,
              //     type: "tween",
              //     ease: "easeInOut",
              //   }}
              // >
              //   <div class="absolute top-32 left-3 w-full ">
              //     <div class="p-3 bg-red-50  z-50  border rounded-2xl shadow-sm w-56">
              //       <div className="flex justify-between">
              //         <nav>
              //           <ul
              //             class="space-y-4  text-left ml-4 text-xl text-[#88448A]"
              //             style={{ fontFamily: "Poppins" }}
              //           >
              //             {navbar.map((item, i) => {
              //               return (
              //                 <li key={i}>
              //                   <NavLink
              //                     className="text-[#9A4C9D] hover:text-[#9A4C9D] text-[20px] "
              //                     activeStyle={{
              //                       color: "rgb(38 3 39)",
              //                       fontWeight: "500",
              //                     }}
              //                     to={item.path}
              //                     onClick={changeState}
              //                   >
              //                     {item.title}
              //                   </NavLink>
              //                 </li>
              //               );
              //             })}
              //           </ul>
              //         </nav>
              //       </div>
              //     </div>
              //   </div>
              // </SidebarWrap>
              <SidebarWrap
              className="h-[100vh]"
                key="first"
                initial={{ x: -250, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                exit={{ x: -280, opacity: 1 }}
                transition={{
                  duration: 0.36,
                  type: "tween",
                  ease: "easeInOut",
                }}
              >
              <MenuWrap>
              <ul className="mt-6" >
                {
                  isAuthenticate && <li> < FaUserCircle id="subdroptoggle" className=' mx-32' style={{fontSize:"4rem", transform:"translateY(-3px)", fontWeight:"bold",color:'#88448a'}}/></li>
                }
                {
                  !isAuthenticate && <li><NavLink to="/home">
                  <img src={Logo} alt="logo" className=" w-32 ml-10 " />
                </NavLink></li>
                }
                {
                  isAuthenticate && <li ><small id="subdroptoggle"  style={{fontSize:"16px", textTransform:'capitalize',color:'#88448a' }} className=' flex justify-center'>Welcome, { user.user_name} </small></li>
                }
                {user && <li><small id="subdroptoggle" className=' flex justify-center' style={{fontSize:"16px",color:'#88448a' }}> Balance: &#8377; { balance } </small></li>}
                {
                  isAuthenticate && <li> <NavLink to="/user-editprofile" id="subdroptoggle" activeStyle={{backgroundColor:'#88448a',color:'white'}}  activeClassName="selected" onClick={()=>setIsMenuOpen(false)} exact> Profile<MdKeyboardArrowRight /> </NavLink> </li>
                }
                {
                  isAuthenticate && <li> <NavLink to="/order" id="subdroptoggle" activeStyle={{backgroundColor:'#88448a',color:'white'}}  activeClassName="selected" onClick={()=>setIsMenuOpen(false)} exact>My Orders<MdKeyboardArrowRight /> </NavLink> </li>
                }
          <li> <NavLink to="/home"  activeStyle={{backgroundColor:'#88448a',color:'white'}} id="subdroptoggle" activeClassName="selected" onClick={()=>setIsMenuOpen(false)} exact> Home<MdKeyboardArrowRight /> </NavLink> </li>
                  <li> <NavLink to="/e-vouchers" activeStyle={{backgroundColor:'#88448a',color:'white'}} id="subdroptoggle" activeClassName="selected" onClick={()=>setIsMenuOpen(false)} exact> E-Vouchers <MdKeyboardArrowRight /> </NavLink> </li>
                  <li> <NavLink to="/products-gifts" activeStyle={{backgroundColor:'#88448a',color:'white'}} id="subdroptoggle" activeClassName="selected" onClick={()=>setIsMenuOpen(false)} exact>Products & Gifts <MdKeyboardArrowRight /> </NavLink>  </li>
  
                  <li> <NavLink to="/contact" id="subdroptoggle" activeStyle={{backgroundColor:'#88448a',color:'white'}}  activeClassName="selected" onClick={()=>setIsMenuOpen(false)} exact> Contact<MdKeyboardArrowRight /> </NavLink> </li>
                  {
                    isAuthenticate && <li> <NavLink to='/'  id="subdroptoggle" activeStyle={{backgroundColor:'#88448a',color:'white'}}  activeClassName="selected" onClick={logoutFutn} exact> LogOut<LogoutOutlined /> </NavLink> </li>
                  }


                 
              </ul>
              
  
          <AddtoCoupon />
          </MenuWrap>
          </SidebarWrap>
            )}

            <div>
              <AnimatePresence exitBeforeEnter>
                {isMenuOpen && (
                  <BackdropWrap
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{
                      duration: 0.36,
                      type: "tween",
                      ease: "easeInOut",
                    }}
                    onClick={() => setIsMenuOpen(false)}
                  />
                )}
              </AnimatePresence>
            </div>
          </div>

          <Link to="/">
            <img src={Logo} alt="logo" className=" w-24 md:hidden" />
          </Link>
          
        </div>
      </div>
    </div>
  );
}

// const NavbarWrap = styled.div`
//   background-color: white;
//   color: #9a4c9d;
//   display: flex;
//   /* align-items:start; */
//   justify-items: flex-start;
//   justify-content: flex-start;

//   .container {
//     width: 100%;
//     margin: auto;

//     ul {
//       margin: 0;
//       display: flex;
//       padding: 0.8rem;
//       align-items: center;
//       justify-content: flex-start;

//       li {
//         list-style: none;
//         font-size: 1.2rem;
//         margin: 0 1.3rem;
//         a {
//           color: #9a4c9d;
//         }
//       }
//     }
//   }
// `;

const BackdropWrap = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: #0a0a0a05;
`;

const SidebarWrap = styled(motion.aside)`
  position: fixed;
  top: 0;
  left: 0;
  width: 75%;
  background-color: #ffffff;
  z-index: 49;
`;


const MenuWrap = styled.div`
.dropdown_menu{
  text-align:left;
    /* height: 167px ; */
    max-height:  167px;
    overflow-y: auto;
    overflow-x: hidden;
    background-color: #f5f5f5;
    svg {
    font-size: 1rem;
    margin-right: 0.2rem;
    }
} 
#subdroptoggle{
        background-color: white;
        font-size: 0.9rem;
        font-weight: 600;
        &:hover{
        
        background-color: var(--brandColor);
        color: white;
        
        }
    }
ul{
    padding-bottom:0.7px;
    background-color: #f5f5f5;
    li {
        a{
        color:#88448a;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding: 0.5rem 0.75rem 0.5rem 0.9rem;
        margin-bottom: 0.3rem;
        transition:0.3s;
        &:hover{
        
        background-color: var(--brandColor);
        color: grey;
        
            }
        }
        list-style: none;
        background-color: white;
        color:grey;
        cursor: pointer;
     
        svg {
            font-size: 1.3rem;
        }
    
        .selected{  
        background-color: var(--brandColor);
        color: white;
        width: 100%;
        display: block;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding: 0.5rem 0.75rem 0.5rem 0.9rem;
        margin-bottom: 0.3rem;
}
    }
}
`